import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Link } from 'gatsby';
import { ExternalLink } from '../../../src/components';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`There are different types of linking within this framework. Here is a run down of each one and when to use it.`}</p>
    <h2>{`Internal Links`}</h2>
    <p>{`If you want to link to something internally, you should use the `}<ExternalLink href="https://www.gatsbyjs.org/docs/gatsby-link/" mdxType="ExternalLink">{`Gatsby Link component`}</ExternalLink>{` as it enables the SPA-like browsing experience.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`Click <Link to="/documentation/recipes/adding-links#internal-links">here</Link> to learn about Links.
`}</code></pre>
    <h2>{`External Links`}</h2>
    <p>{`If you want to link to something external of the documentation, you should use the `}<Link to="/documentation/components#external-link" mdxType="Link">{`ExternalLink`}</Link>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`Click <ExternalLink href="https://xedi.github.io/sdk-js/documentation/components#external-link">here</ExternalLink> to learn about external links
`}</code></pre>
    <h2>{`Source Links`}</h2>
    <p>{`If you want to link to source code, you should use the `}<InlineCode mdxType="InlineCode">{`<`}{`SourceLink`}{`>`}</InlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<SourceLink href="https://github.com/xedi/sdk-js/blob/master/docs/src/components/source_link.js">View Source</SourceLink>
`}</code></pre>
    <h2>{`Repo Links`}</h2>
    <p>{`If you want to link to a page within the GitHub repository then use the `}<InlineCode mdxType="InlineCode">{`<`}{`RepoLink`}{`>`}</InlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RepoLink href="packages">Packages on GitHub</RepoLink>
`}</code></pre>
    <h3>{`Different Icon`}</h3>
    <p>{`You can also change the icon using the `}<InlineCode mdxType="InlineCode">{`icon`}</InlineCode>{` property.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<RepoLink icon={Package} href="packages">Packages on GitHub</RepoLink>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      